/*!	
* FitText.js 1.0 jQuery free version - DEBUG VERSION
*
* Copyright 2011, Dave Rupert http://daverupert.com 
* Released under the WTFPL license 
* http://sam.zoy.org/wtfpl/
* Modified by Slawomir Kolodziej http://slawekk.info
* Debug version with comprehensive logging
*
* Date: Tue Aug 09 2011 10:45:54 GMT+0200 (CEST)
*/
(function(){
  console.log('[FitText Debug] Script loaded and executing');

  var addEvent = function (el, type, fn) {
    console.log('[FitText Debug] Adding event listener:', type, 'to element:', el);
    if (el.addEventListener)
      el.addEventListener(type, fn, false);
    else
      el.attachEvent('on'+type, fn);
  };
  
  var extend = function(obj,ext){
    console.log('[FitText Debug] Extending object with:', ext);
    for(var key in ext)
      if(ext.hasOwnProperty(key))
        obj[key] = ext[key];
    return obj;
  };

  window.fitText = function (el, kompressor, options) {
    console.log('[FitText Debug] fitText called with:');
    console.log('  - Element:', el);
    console.log('  - Element type:', typeof el);
    console.log('  - Element is null:', el === null);
    console.log('  - Element is undefined:', el === undefined);
    console.log('  - Kompressor:', kompressor);
    console.log('  - Options:', options);

    // Safety check for null/undefined element
    if (!el) {
      console.error('[FitText Debug] ERROR: Element is null or undefined!');
      console.log('[FitText Debug] DOM ready state:', document.readyState);
      console.log('[FitText Debug] Available elements with fittext id:', document.querySelectorAll('#fittext'));
      return null;
    }

    var settings = extend({
      'minFontSize' : -1/0,
      'maxFontSize' : 1/0
    },options);
    
    console.log('[FitText Debug] Final settings:', settings);

    var fit = function (el) {
      console.log('[FitText Debug] Fitting element:', el);
      console.log('  - Element clientWidth:', el.clientWidth);
      console.log('  - Element offsetWidth:', el.offsetWidth);
      console.log('  - Element computed style:', window.getComputedStyle ? window.getComputedStyle(el) : 'Not available');
      
      var compressor = kompressor || 1;
      console.log('[FitText Debug] Using compressor value:', compressor);

      var resizer = function () {
        var clientWidth = el.clientWidth;
        var calculatedSize = clientWidth / (compressor * 10);
        var minSize = parseFloat(settings.minFontSize);
        var maxSize = parseFloat(settings.maxFontSize);
        
        console.log('[FitText Debug] Resizer called:');
        console.log('  - Client width:', clientWidth);
        console.log('  - Calculated size (before limits):', calculatedSize);
        console.log('  - Min font size:', minSize);
        console.log('  - Max font size:', maxSize);
        
        var finalSize = Math.max(Math.min(calculatedSize, maxSize), minSize);
        console.log('  - Final font size:', finalSize + 'px');
        
        el.style.fontSize = finalSize + 'px';
        console.log('  - Applied font size:', el.style.fontSize);
      };

      // Call once to set.
      console.log('[FitText Debug] Calling resizer for initial sizing');
      resizer();

      // Bind events
      console.log('[FitText Debug] Binding resize events');
      addEvent(window, 'resize', resizer);
      addEvent(window, 'orientationchange', resizer);
    };

    console.log('[FitText Debug] Checking element type for iteration');
    console.log('  - Element has length property:', 'length' in el);
    console.log('  - Element length value:', el.length);

    if (el.length) {
      console.log('[FitText Debug] Processing element collection of length:', el.length);
      for(var i=0; i<el.length; i++) {
        console.log('[FitText Debug] Processing element at index:', i, el[i]);
        fit(el[i]);
      }
    } else {
      console.log('[FitText Debug] Processing single element');
      fit(el);
    }

    console.log('[FitText Debug] fitText completed successfully');
    // return set of elements
    return el;
  };
  
  console.log('[FitText Debug] fitText function ready and attached to window');
})();